import { Injectable } from '@angular/core';
import { WsService } from './ws/ws.service';
import { Router } from '@angular/router';
import { SessionService } from './session.service';
import { CrashMessageService } from './crash-message.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class LogoutService {
     constructor(
          private ws: WsService,
          private router: Router,
          private crash: CrashMessageService,
          private session: SessionService,
          private dialog: MatDialog
     ) {}

     run(): Promise<{ ok: boolean }> {
          return new Promise((resolve) => {
               // Close all dialogs
               this.dialog.closeAll();
               // Logout if logged in
               if (this.session.get()) {
                    this.ws.auth
                         .logout()
                         .then(() => {
                              this.session.clear();
                              this.router.navigateByUrl('/');
                              resolve({ ok: true });
                         })
                         .catch((err) => {
                              console.error(`Logout error `, err);
                              this.session.clear();
                              this.router.navigateByUrl('/crash');
                              this.crash.setMessage(`
                Erreur: ${(err && err.error && err.error.ctxCode) || '-'}
                Message: ${err.message}
              `);
                              resolve({ ok: false });
                         });
               } else {
                    resolve({ ok: true });
               }
          });
     }
}
